const DEFAULT_DIGITALOCEAN_IMAGE_BASE_URL =
  "https://kiiramotorsstorage.blob.core.windows.net/assets/";

export const DIGITALOCEAN_IMAGE_BASE_URL = (
  process.env.REACT_APP_DIGITALOCEAN_IMAGE_BASE_URL ||
  DEFAULT_DIGITALOCEAN_IMAGE_BASE_URL
).replace(/\/+$/, "");

export const digitalOceanImageUrl = (path: string) =>
  `${DIGITALOCEAN_IMAGE_BASE_URL}/${path.replace(/^\/+/, "")}`;
